import { render, staticRenderFns } from "./Page1.vue?vue&type=template&id=9f1aba94"
import script from "./Page1.vue?vue&type=script&lang=ts"
export * from "./Page1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports